import { TestSetStatusEnum, SendTypeEnum } from "./GeneralEnums";

export const testSetStatusOptions = [
    { key: TestSetStatusEnum.NoStart, text: "En espera del identificador del set de pruebas"},
    { key: TestSetStatusEnum.WaitForFirstDocument, text: "Esperando por envio desde un doc desde el ERP"},
    { key: TestSetStatusEnum.FirstDocumentInValidation, text: "Esperando la validación por la DIAN del primer documento enviado"},
    { key: TestSetStatusEnum.FirstDocumentRejected, text: "El documento validado por la DIAN presenta inconvenientes. Revisa detalle del error y reenvía un nuevo documento"},
    { key: TestSetStatusEnum.RepliesGenerationProcess, text: "Primer documento aceptado por la DIAN, en proceso de generación del set de pruebas"},
    { key: TestSetStatusEnum.WaitingForConfirmReplies, text: "Set de pruebas enviado a la DIAN. En proceso de validación"},
    { key: TestSetStatusEnum.OneOrMoreDocsNoConfirmed, text: "El documento enviado a la DIAN presenta inconvenientes. Revisa el detalle del error y reenvía un nuevo documento"},
    { key: TestSetStatusEnum.WaitForUserConfirm, text: "El set de pruebas ha finalizado. Debes ubicarte en el paso 3 y confirmar el estado"},
    { key: TestSetStatusEnum.Sucess, text: "El set de pruebas ha finalizado de manera satisfactoria. Haz quedado habilitado en ambiente productivo"},
  ];

  export const sendTypeEnumOptions = [
    { key: SendTypeEnum.enable, text: "En proceso de habilitación"},
    { key: SendTypeEnum.production, text: "En ambiente productivo"},
    { key: SendTypeEnum.productiontest, text: "En ambiente productivo"},
  ];
  
  export const getSendTypeEnumOptions = (key: number) => {
    return sendTypeEnumOptions.find((type) => type.key === key)?.text || "No se encontro el enumerador";
  };

  export const getTestSetStatusOptions = (key: number) => {
    return testSetStatusOptions.find((type) => type.key === key)?.text || "No se encontro el enumerador";
  };